import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt";
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import OurLocation from "../components/OurLocation";
import LocationContentDelhi from "../components/main/LocationContentDelhi";
import PopupOffer from "../components/PopupOffer";
import GroomingFormComponent from "../components/form/GroomingFormComponent";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const DelhiPage = () => {

  const [openForm, setOpenForm] = useState(false);

  const [offerPopup, setOfferPopup] = useState(false);

      const [petGroom, setPetGroom] = useState("Dog")
  

  useEffect( () => {

    const timer = setTimeout( () => {
      setOfferPopup(true)
    }, 15000)

    return () => clearInterval(timer)

  },[])
  
  

  const headerData = {
    heading: "Pet Grooming at Home in Delhi",
    text: "Same Day Booking - Smart Choice for Delhi Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [
      {
        question: "What makes your at-home pet grooming service different?",
        text: [
          "We bring the full salon experience to your home! Benefits include:",

          "✅ Same-day bookings available (no extra charge)",
          "✅ Personalized 1-on-1 care for your pet",
          "✅ 100% stress-free (no travel, no crowded salons)",
          "✅ Certified groomers using vet-approved products",
        ],
        points: [],
      },
      {
        question: "How do I book a same-day appointment?",
        text: [
          "Simply call/WhatsApp us at [Your Number]. We’ll confirm a groomer’s availability in your area immediately—no extra fees, ever.",
        ],
        points: [],
      },
      {
        question: "What’s included in your basic grooming package?",
        text: [
          "Every session includes:",
          "✔ Gentle bath with hypoallergenic shampoo",
          "✔ Blow-dry & brushing",
          "✔ Nail trimming & ear cleaning",
          "✔ Paw pad cleaning",
          "✔ Sanitized tools (used only for your pet)",
        ],
        points: [],
      },
      {
        question: "Do you charge extra for urgent bookings or weekends?",
        text: [
          "Never! Unlike pet salons, we never add hidden charges—whether it’s same-day, weekends, or holidays.",
        ],
        points: [],
      },
      {
        question: "What if my pet is anxious or aggressive?",
        text: [
          "Our groomers are trained in fear-free techniques (no muzzles/sedation). For extreme cases, we’ll guide you on gradual acclimatization.",
        ],
        points: [],
      },
      {
        question: "How long does a grooming session take?",
        text: [""],
        points: [
          "Small dogs/cats: 60–90 mins",
          "Medium/large dogs: 90–120 mins",
          "Depends on the coat type and the pet’s comfort level.",
        ],
      },
      {
        question: "What areas of Delhi do you serve?",
        text: [
          "We cover all of Delhi-NCR, including: • South Delhi • North Delhi • Gurugram • Noida • Dwarka • And more!",
        ],
        points: [],
      },
      {
        question: "What safety measures do you take?",
        text: [""],
        points: [
          "No cage drying (gentle towel/blow-dry only)",
          "Separate tools per pet (sanitized post-use)",
          "Temperature-controlled water",
          "Groomers wear gloves/aprons",
        ],
      },
      {
        question: " Can I reschedule or cancel?",
        text: [
          "Yes! Just notify us 2 hours in advance. No cancellation fees—we understand plans change.",
        ],
        points: [],
      },
      //   {
      //     question: "",
      //     text: [""],
      //     points: [],
      //   },
    ],
  };

  const locationData = {
    data: [
      "North Delhi",
      "South Delhi",
      "East Delhi",
      "West Delhi",
      "Central Delhi",
      "New Delhi (Lutyens' Delhi)",
      "North West Delhi",
      "South West Delhi",
      "Connaught Place (CP)",
      "Karol Bagh",
      "Chandni Chowk",
      "Rajouri Garden",
      "Patel Nagar",
      "Lajpat Nagar",
      "South Extension I & II",
      "Greater Kailash I, II",
      "Vasant Kunj",
      "Vasant Vihar",
      "Saket",
      "Malviya Nagar",
      "Hauz Khas",
      "Green Park",
      "Defence Colony",
      "Rohini (Sectors 1 to 30+)",
      "Pitampura",
      "Dwarka (Sectors 1 to 23)",
      "Janakpuri",
      "Mayur Vihar Phases I–III",
      "Preet Vihar",
      "Shahdara",
      "Dilshad Garden",
      "Seemapuri",
      "Nangloi",
      "Najafgarh",
      "Delhi NCR Master Plan Zones",
      "L-Zone (Dwarka Extension)",
      "K-Zone (Northwest Urban Ext.)",
      "N-Zone (Narela Sub-city)",
      "P-Zone (Bawana, Holambi)",
    ],
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id":
          "https://fluffytouch.in/pet-grooming-at-home/delhi#LocalBusiness",
        name: "FluffyTouch Pet Grooming",
        description:
          "Professional at-home pet grooming service in Delhi. Certified groomers, same-day appointments, stress-free grooming for dogs and cats.",
        url: "https://fluffytouch.in/pet-grooming-at-home/delhi",
        telephone: "+919658189189",
        image:
          "https://fluffytouch.in/static/media/about.c29fc5fc6ae0647eeecd.jpg",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Delhi",
          addressRegion: "Delhi",
          addressCountry: "IN",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: 28.6139,
          longitude: 77.209,
        },
        areaServed: [
          { "@type": "Place", name: "North Delhi" },
          { "@type": "Place", name: "South Delhi" },
          { "@type": "Place", name: "East Delhi" },
          { "@type": "Place", name: "West Delhi" },
          { "@type": "Place", name: "Central Delhi" },
          { "@type": "Place", name: "New Delhi (Lutyens' Delhi)" },
          { "@type": "Place", name: "North West Delhi" },
          { "@type": "Place", name: "South West Delhi" },
          { "@type": "Place", name: "Connaught Place" },
          { "@type": "Place", name: "Karol Bagh" },
          { "@type": "Place", name: "Chandni Chowk" },
          { "@type": "Place", name: "Rajouri Garden" },
          { "@type": "Place", name: "Patel Nagar" },
          { "@type": "Place", name: "Lajpat Nagar" },
          { "@type": "Place", name: "South Extension" },
          { "@type": "Place", name: "Greater Kailash" },
          { "@type": "Place", name: "Vasant Kunj" },
          { "@type": "Place", name: "Saket" },
          { "@type": "Place", name: "Malviya Nagar" },
          { "@type": "Place", name: "Hauz Khas" },
          { "@type": "Place", name: "Green Park" },
          { "@type": "Place", name: "Defence Colony" },
          { "@type": "Place", name: "Rohini" },
          { "@type": "Place", name: "Pitampura" },
          { "@type": "Place", name: "Dwarka" },
          { "@type": "Place", name: "Janakpuri" },
          { "@type": "Place", name: "Mayur Vihar" },
          { "@type": "Place", name: "Preet Vihar" },
          { "@type": "Place", name: "Shahdara" },
          { "@type": "Place", name: "Dilshad Garden" },
          { "@type": "Place", name: "Seemapuri" },
          { "@type": "Place", name: "Nangloi" },
          { "@type": "Place", name: "Najafgarh" },
          { "@type": "Place", name: "L-Zone" },
          { "@type": "Place", name: "K-Zone" },
          { "@type": "Place", name: "N-Zone" },
          { "@type": "Place", name: "P-Zone" },
        ],
        openingHoursSpecification: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "07:00",
          closes: "21:00",
        },
        sameAs: [
          "https://www.facebook.com/Fluffytouchoffc/",
          "https://www.instagram.com/fluffytouchofficial",
          "https://twitter.com/fluffytouchoffc",
          "https://www.linkedin.com/company/fluffytouch/",
          "https://www.youtube.com/channel/UCcUZcYkiAv8t5ruDxYvVn_A",
          "https://pin.it/3ZIwZk4",
        ],
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "1000",
        },
        offers: {
          "@type": "Offer",
          name: "Delhi Launch Offer – 20% Off",
          description:
            "Use code DELHILOVE for 20% off your first booking in Delhi.",
          price: "899",
          priceCurrency: "INR",
          url: "https://fluffytouch.in/pet-grooming-at-home/delhi",
        },
      },
      {
        "@type": "Service",
        "@id": "https://fluffytouch.in/pet-grooming-at-home/delhi#Service",
        name: "At-Home Pet Grooming in Delhi",
        description:
          "Certified mobile grooming for dogs and cats in Delhi. Includes baths, haircuts, flea treatments, spa packages, and more.",
        provider: {
          "@id":
            "https://fluffytouch.in/pet-grooming-at-home/delhi#LocalBusiness",
        },
        areaServed: [
          "Delhi",
          "South Delhi",
          "East Delhi",
          "West Delhi",
          "North Delhi",
          "NCR",
          "Connaught Place",
          "Dwarka",
          "Greater Kailash",
          "Vasant Kunj",
        ],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Delhi Pet Grooming Services",
          itemListElement: [
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Basic Grooming",
                description:
                  "Includes hypoallergenic bath, nail trim, ear cleaning, and blow-dry. Starting at ₹899.",
              },
              price: "899",
              priceCurrency: "INR",
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "VIP Spa Package",
                description:
                  "Includes breed-specific cut, pawdicure, blueberry facial, and organic neem rinse. ₹1499.",
              },
              price: "1499",
              priceCurrency: "INR",
            },
            {
              "@type": "Offer",
              itemOffered: {
                "@type": "Service",
                name: "Emergency De-Matting",
                description:
                  "Specialized mat removal for severely tangled fur (common in Delhi summers).",
              },
              priceCurrency: "INR",
            },
          ],
        },
      },
      {
        "@type": "FAQPage",
        "@id": "https://fluffytouch.in/pet-grooming-at-home/delhi#FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What areas in Delhi do you serve?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "We serve all of Delhi including South, North, East, West, Central, Dwarka, Rohini, Greater Kailash, Vasant Kunj, and more.",
            },
          },
          {
            "@type": "Question",
            name: "Is same-day booking available?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, same-day appointments are available across Delhi with no extra charge.",
            },
          },
          {
            "@type": "Question",
            name: "What’s included in basic grooming?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Our basic grooming includes a gentle bath, blow-dry, nail clipping, ear cleaning, and brushing.",
            },
          },
          {
            "@type": "Question",
            name: "Do you handle anxious pets?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, our groomers are trained in low-stress, fear-free grooming methods.",
            },
          },
          {
            "@type": "Question",
            name: "Are your services suitable for summer heat and pollution?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes, we offer summer cuts, paw wax, and anti-pollution shampoos ideal for Delhi conditions.",
            },
          },
          {
            "@type": "Question",
            name: "What payment methods do you accept?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "You can pay after the service via cash, UPI, or card. No advance required.",
            },
          },
        ],
      },
    ],
  };

  return (
    <div>
      <div className="delhi-page">
        <Helmet>
          <title>
            Professional Pet Grooming at Home in Delhi | FluffyTouch
          </title>
          <meta
            name="description"
            content="
          🐶🐱 Expert mobile pet grooming in Delhi! Pain-free, vet-approved care at your doorstep. Book now for a happier, cleaner pet! - FluffyTouch

        "
          />

           <script type="application/ld+json">{JSON.stringify(schema)}</script>
          
        </Helmet>

        {openForm ? <GroomingFormComponent setDynamicForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav /> 

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

        <LocationGroomingPackageComponent petGroom={petGroom} setPetGroom={setPetGroom} />

        <LocationComponent location="Delhi" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContentDelhi />

        <OurLocation />

        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default DelhiPage;
